const messages = {
    Register: {
        message: 'Organice sus transacciones'
    },
    hello: 'JAMURCO EPSANxxxx HELLO'

}

export default messages